var map = {
	"./img/general/RequestConsulting.svg": "0c7a",
	"./img/general/lamp.svg": "98e7",
	"./img/layout/sidebar-logo-text.svg": "31b8",
	"./img/layout/sidebar-logo.svg": "1f64",
	"./img/static/favicon.ico": "76a2",
	"./logo.png": "cf05",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";